export default __webpack_public_path__ + "static/media/1979.39192b4a.png";